import { matchPath } from 'react-router-dom';

export function getActiveLink(path: string, pathname: string) {
  return path ? !!matchPath({ path: path, end: false }, pathname) : false;
}
